import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  startScreen: {
    fontFamily: theme.fonts.family.primary,
  },
  startScreenContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  titleCommon: {
    textAlign: 'center',
  },
  title: {
    margin: '10px 0',
    fontStyle: 'normal',
    fontFamily: theme.fonts.family.primary,
    fontSize: theme.fonts.sizes.font18PX,
    fontWeight: 900,
    color: theme.colors.light.freshPowder,
  },
  subTitle: {
    margin: '10px 0',
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: theme.fonts.sizes.font10PX,
    color: theme.colors.light.lightSteelBlue,
  },
  tableContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 40,
    padding: 14,
    borderRadius: 10,
    border: `1px solid ${theme.colors.light.lightSteelBlue}`,
  },
  startScreenImg: {
    display: 'block',
    height: '25vh',
    margin: '10px auto',
  },
  tableLettering: {
    margin: '0 8px 0 28px',
    fontWeight: 500,
    fontSize: theme.fonts.sizes.font14PX,
    color: theme.colors.light.lightSteelBlue,
    position: 'relative',
    '&:before': {
      content: '""',
      display: 'block',
      width: 2,
      height: '100%',
      backgroundColor: theme.colors.light.lightSteelBlue,
      position: 'absolute',
      top: 0,
      left: -13,
      zIndex: 1,
    },
  },
  tableNumber: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    padding: '0px 2px',
    fontWeight: 500,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    borderRadius: 2,
  },
  buttonGroup: {
    width: '100%',
  },
  buttonSeparator: {
    margin: '0 0 16px 0',
    fontSize: theme.fonts.sizes.font12PX,
    textTransform: 'uppercase',
    fontWeight: 700,
    textAlign: 'center',
    color: theme.colors.light.lightSteelBlue,
    position: 'relative',
    '&:before, &:after': {
      content: '""',
      display: 'block',
      width: '45%',
      height: 1,
      backgroundColor: theme.colors.light.lightSteelBlue,
      position: 'absolute',
      top: '50%',
      zIndex: 1,
      transform: 'translateY(-50%)',
    },

    '&:before': {
      left: 0,
    },

    '&:after': {
      right: 0,
    },
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    height: 46,
    width: '100%',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.dark.steelBlue,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));
